export default {
  pages: {
    key: "title",
    data: [
      {title: 'Home',   url: '/',      icon: 'HomeIcon', is_bookmarked: false},
      {title: 'تکمیل اطلاعات', url: '/panel/user-info', icon: 'FileIcon', is_bookmarked: false},
    ]
  }
}
